import { createFileRoute, redirect } from '@tanstack/react-router'
import { KnowledgeBasesPage } from '@/pages/KnowledgeBases/KnowledgeBasesPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/knowledge-bases')({
  component: KnowledgeBasesPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/knowledge-bases')) {
      throw redirect({ to: '/' })
    }
  },
})
